import { HeaderTabProps } from '@k3/core/dist/src/lib/components/pages/configurator/GroupsNavigation';
import {
  AppBar,
  createTheme,
  Link,
  Paper,
  Stack,
  Toolbar,
  Typography,
  useTheme,
} from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { HeaderTabs, useIsEditor } from '@k3/core';
import { useMemo } from 'react';
import { useIsKioskMode } from '../../hooks/useIsKioskMode';
import { useUrls } from '../../hooks/useUrls';
import { useDealerTheme } from '../../hooks/useDealerTheme';

export const Header = (props: HeaderTabProps) => {
  const originalTheme = useTheme();
  const urls = useUrls();
  const { dealerMain } = useDealerTheme();
  const theme = useMemo(
    () =>
      createTheme(originalTheme, {
        palette: {
          primary: {
            main: '#fff',
          },
        },
      }),
    [originalTheme]
  );
  const editor = useIsEditor();
  const kiosk = useIsKioskMode();
  const LogoElement = (
    <Stack
      sx={{
        backgroundImage: `url(${urls.logo})`,
        height: urls.logoDimensions.height + 'px',
        width: urls.logoDimensions.width + 'px',
        backgroundRepeat: 'no-repeat',
        objectFit: 'contain',
      }}
    />
  );

  return (
    <ThemeProvider theme={theme}>
      <AppBar position="static" data-cy="groupHeader">
        <Toolbar
          sx={{
            display: 'grid',
            gridTemplateColumns: '1fr auto 1fr',
            gap: 2,
            color: 'common.black',
            pr: '0 !important',
            borderBottom: '1px solid #dedede',
          }}
        >
          <Stack sx={{ flexDirection: 'row', justifyContent: 'flex-start' }}>
            {!kiosk && (
              <Link
                href={urls.shopUrl}
                target="_parent"
                rel="noreferrer"
                sx={{ alignItems: 'center', display: 'flex', pr: 2 }}
              >
                <Typography sx={{ color: dealerMain }} variant="body2">
                  Zurück zum Shop
                </Typography>
              </Link>
            )}

            {kiosk ? (
              <div
                style={{
                  width: '262px',
                }}
              >
                {LogoElement}
              </div>
            ) : (
              <a
                href={urls.shopUrl}
                target="_blank"
                rel="noreferrer"
                style={{
                  width: '262px',
                }}
              >
                {LogoElement}
              </a>
            )}
          </Stack>
          {kiosk ? (
            <Stack />
          ) : (
            <Stack
              sx={{
                backgroundImage: `url(${urls.support})`,
                height: urls.supportDimensions?.height ?? '38px',
                width: urls.supportDimensions?.width ?? '272px',
                backgroundRepeat: 'no-repeat',
                objectFit: 'contain',
              }}
            />
          )}
          <Stack sx={{ flexDirection: 'row', justifyContent: 'flex-end' }}>
            {editor ? (
              <HeaderTabs {...props} />
            ) : (
              <CustomHeaderTabs {...props} />
            )}
          </Stack>
        </Toolbar>
      </AppBar>
    </ThemeProvider>
  );
};

export const CustomHeaderTabs = (props: HeaderTabProps) => {
  const visibleGroups = useMemo(
    () =>
      props.groups.filter(
        (g) => !props.invisibleGroups.some((ig) => ig.id === g.id)
      ),
    [props.groups, props.invisibleGroups]
  );
  const { dealerMain } = useDealerTheme();
  return (
    <Stack flexDirection="row" sx={{ m: 0 }}>
      {visibleGroups.map((group, index) => {
        const isActive = group.id == props.activeGroupId;
        return (
          <Paper
            elevation={2}
            square
            key={group.id}
            sx={{
              width: '120px',
              height: '80px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
              color: isActive ? `${dealerMain} !important` : undefined,
              backgroundColor: isActive
                ? undefined
                : 'rgb(246, 246, 246) !important',
              cursor: 'pointer',
              boxShadow: '0 0 5px 1px hsla(0,0%,47%,.3)',
            }}
            onClick={(e) => props.handleTabChange(e, group.id.toString())}
          >
            <Typography variant="body2">Schritt {index + 1}</Typography>
            <Typography>
              <b>{group.label}</b>
            </Typography>
          </Paper>
        );
      })}
    </Stack>
  );
};
